{
  "grid": {
    "groupPanelEmpty": "Ziehen Sie einen Spaltentitel hierher um nach dieser Spalte zu gruppieren",
    "pagerItemsPerPage": "Einträge pro Seite",
    "pagerInfo": "{0} - {1} von {2} Einträgen",
    "pagerFirstPage": "Zur ersten Seite",
    "pagerPreviousPage": "Seite zurück",
    "pagerNextPage": "Nächste Seite",
    "pagerLastPage": "Zur letzten Seite",
    "pagerPage": "Seite",
    "pagerOf": "von",
    "pagerTotalPages": "{0}",
    "filterClearButton": "Löschen",
    "filterEqOperator": "Ist gleich",
    "filterNotEqOperator": "Ist nicht gleich",
    "filterIsNullOperator": "Ist leer",
    "filterIsNotNullOperator": "Ist nicht leer",
    "filterIsEmptyOperator": "Ist leer",
    "filterIsNotEmptyOperator": "Ist nicht leer",
    "filterStartsWithOperator": "Beginnt mit",
    "filterContainsOperator": "Enthält",
    "filterNotContainsOperator": "Enthält nicht",
    "filterEndsWithOperator": "Endet mit",
    "filterGteOperator": "Größer oder gleich",
    "filterGtOperator": "Größer als",
    "filterLteOperator": "Kleiner oder gleich",
    "filterLtOperator": "Kleiner als",
    "filterIsTrue": "Wahr",
    "filterIsFalse": "Falsch",
    "filterBooleanAll": "(Alle)",
    "filterAfterOrEqualOperator": "Danach oder gleich",
    "filterAfterOperator": "Danach",
    "filterBeforeOperator": "Davor",
    "filterBeforeOrEqualOperator": "Davor oder gleich",
    "noRecords": "Keine Einträge vorhanden.",
    "filterAriaLabel": "Filter",
    "filterCheckAll": "Alle prüfen",
    "filterChooseOperator": "Operator wählen",
    "filterSelectedItems": "gewählte Objekte",
    "filterSubmitButton": "Filter",
    "filterTitle": "Filter",
    "filterAndLogic": "Und",
    "filterOrLogic": "Oder",
    "groupColumn": "Spalte gruppieren",
    "searchPlaceholder": "Suche",
    "sortAriaLabel": "Sortierbar",
    "sortAscending": "Aufsteigend sortieren",
    "sortDescending": "Absteigend sortieren",
    "ungroupColumn": "Spaltengruppierung aufheben"
  },
  "filter": {
    "eqOperator": "Ist gleich zu",
    "notEqOperator": "Ist ungleich zu",
    "isNullOperator": "Ist null",
    "isNotNullOperator": "Ist nicht null",
    "isEmptyOperator": "Ist leer",
    "isNotEmptyOperator": "Ist nicht leer",
    "startsWithOperator": "Beginnt mit",
    "containsOperator": "Enthält",
    "notContainsOperator": "Enthält nicht",
    "endsWithOperator": "Endet mit",
    "gteOperator": "Ist gleich oder größer wie",
    "gtOperator": "Ist größer wie",
    "lteOperator": "Ist gleich oder kleiner wie",
    "ltOperator": "Ist kleiner wie",
    "isTrue": "Ist wahr",
    "isFalse": "Ist falsch",
    "afterOrEqualOperator": "Ist gleich zu oder nach",
    "afterOperator": "Ist nach",
    "beforeOperator": "Ist vor",
    "beforeOrEqualOperator": "Ist gleich zu oder vor",
    "andLogic": "Und",
    "orLogic": "Oder",
    "addExpression": "Ausdruck hinzufügen",
    "addGroup": "Gruppe hinzufügen",
    "close": "Schließen"
  },
  "dateinput": {
    "increment": "Wert erhöhen",
    "decrement": "Wert verringern"
  },
  "calendar": {
    "today": "Heute"
  },
  "datepicker": {
    "toggleCalendar": "Kalender ein-/ausblenden"
  },
  "daterangepicker": {
    "swapStartEnd": "Start- und Enddatum tauschen",
    "start": "Start",
    "end": "Ende",
    "separator": " "
  },
  "datetimepicker": {
    "date": "Datum",
    "time": "Uhrzeit",
    "toggleDateTimeSelector": "Datum/Uhrzeit-Auswahl anzeigen/verstecken",
    "cancel": "Abbrechen",
    "set": "Übernehmen"
  },
  "editor": {
    "bold": "Fett",
    "italic": "Kursiv",
    "underline": "Unterstreichen",
    "strikethrough": "Durchstreichen",
    "subscript": "Tiefgestellt",
    "superscript": "Hochgestellt",
    "unlink": "Link entfernen",
    "undo": "Rückgängig",
    "redo": "Wiederholen",
    "fontSize": "Schriftgröße",
    "fontName": "Schriftart",
    "format": "Format",
    "alignLeft": "Linksbündig",
    "alignRight": "Rechtsbündig",
    "alignCenter": "Zentriert",
    "alignJustify": "Blocksatz",
    "indent": "Einzug vergrößern",
    "outdent": "Einzug verkleinern",
    "orderedList": "Nummerierung",
    "bulletList": "Aufzählungszeichen",
    "createTable": "Tabelle hinzufügen",
    "insertTableHint": "{0} x {1} Tabelle erzeugen",
    "addRowBefore": "Zeile oberhalb einfügen",
    "addRowAfter": "Zeile unterhalb einfügen",
    "addColumnBefore": "Spalte davor einfügen",
    "addColumnAfter": "Spalte danach einfügen",
    "deleteRow": "Zeile löschen",
    "deleteColumn": "Spalte löschen",
    "deleteTable": "Tabelle löschen",
    "mergeCells": "Zellen verbinden",
    "splitCell": "Zellen teilen",
    "hyperlink": "Link einfügen",
    "hyperlink-dialog-title": "Link einfügen",
    "hyperlink-dialog-content-address": "Webadresse",
    "hyperlink-dialog-content-title": "Titel",
    "hyperlink-dialog-content-newwindow": "Link in neuem Fenster öffnen",
    "hyperlink-dialog-cancel": "Abbrechen",
    "hyperlink-dialog-insert": "Einfügen",
    "image": "Bild einfügen",
    "image-dialog-title": "Bild einfügen",
    "image-address": "Webadresse",
    "image-title": "Titel",
    "image-altText": "Alternativtext",
    "image-width": "Breite (px)",
    "image-height": "Höhe (px)",
    "image-cancel": "Abbrechen",
    "image-insert": "Einfügen",
    "viewHtml": "HTML anzeigen",
    "viewHtml-dialog-title": "HTML anzeigen",
    "viewHtml-cancel": "Abbrechen",
    "viewHtml-update": "Aktualisieren"
  },
  "timepicker": {
    "now": "JETZT",
    "selectNow": "Aktuelle Uhrzeit auswählen",
    "cancel": "Abbrechen",
    "set": "Übernehmen",
    "toggleTimeSelector": "Uhrzeit-Auswahl anzeigen/verstecken",
    "toggleClock": "Uhr umschalten"
  },
  "dropdowns": {
    "nodata": "Keine Daten vorhanden",
    "clear": "Löschen"
  },
  "numerictextbox": {
    "increment": "Wert erhöhen",
    "decrement": "Wert verringern"
  },
  "upload": {
    "cancel": "Abbrechen",
    "clearSelectedFiles": "Löschen",
    "dropFilesHere": "Dateien zum Hochladen hier ablegen",
    "headerStatusUploaded": "Abgeschlossen",
    "headerStatusUploading": "Hochladen...",
    "invalidFileExtension": "Dateityp nicht erlaubt.",
    "invalidFiles": "Ungültige Datei(en). Bitte prüfen Sie die Voraussetzungen zum Hochladen.",
    "invalidMaxFileSize": "Dateigröße überschritten.",
    "invalidMinFileSize": "Dateigröße unterschritten.",
    "remove": "Entfernen",
    "retry": "Wiederholen",
    "select": "Dateien auswählen...",
    "uploadSelectedFiles": "Hochladen",
    "total": "Gesamt",
    "files": "Dateien"
  },
  "scheduler": {
    "editorValidationRequired": "Feld ist erforderlich.",
    "editorValidationStart": "Die Startzeit muss vor der Endzeit liegen.",
    "editorValidationEnd": "Die Endzeit muss nach der Startzeit liegen.",
    "allEvents": "Alle Ereignisse",
    "allDay": "ganztägig",
    "today": "Heute",
    "dayViewTitle": "Tag",
    "monthViewTitle": "Monat",
    "weekViewTitle": "Woche",
    "workWeekViewTitle": "Arbeitswoche",
    "timelineViewTitle": "Zeitplan",
    "agendaViewTitle": "Agenda",
    "deleteTitle": "Löschen",
    "previousTitle": "Zurück",
    "nextTitle": "Weiter",
    "showFullDay": "Ganztägig anzeigen",
    "showWorkDay": "Geschäftszeiten anzeigen",
    "editOccurrence": "Aktuelles Vorkommen bearbeiten",
    "editorSeries": "Gesamte Serie bearbeiten",
    "editorRecurringConfirmation": "Möchten Sie nur dieses Ereignis oder die gesamte Serie bearbeiten?",
    "editorRecurringDialogTitle": "Wiederkehrendes Ereignis bearbeiten",
    "editorSave": "Speichern",
    "editorCancel": "Abbrechen",
    "editorDelete": "Löschen",
    "editorTitle": "Ereignis",
    "editorEventTitle": "Titel",
    "editorEventStart": "Beginn",
    "editorEventStartTimeZone": "Zeitzone Beginn",
    "editorEventEnd": "Ende",
    "editorEventEndTimeZone": "Zeitzone Ende",
    "editorEventAllDay": "Ganztägiges Ereignis",
    "editorEventDescription": "Beschreibung",
    "editorEventSeparateTimeZones": "Ende in einer anderen Zeitzone",
    "editorEventTimeZone": "Zeitzone angeben",
    "recurrenceEditorRepeat": "Wiederholen",
    "recurrenceEditorDailyInterval": "Tag(e)",
    "recurrenceEditorDailyRepeatEvery": "Wiederholung jeden",
    "recurrenceEditorWeeklyInterval": "Woche(n)",
    "recurrenceEditorWeeklyRepeatEvery": "Wiederholung jede",
    "recurrenceEditorWeeklyRepeatOn": "Wiederholung am",
    "recurrenceEditorMonthlyDay": "Tag",
    "recurrenceEditorMonthlyInterval": "Monat(e)",
    "recurrenceEditorMonthlyRepeatEvery": "Wiederholung jeden",
    "recurrenceEditorMonthlyRepeatOn": "Wiederholung am",
    "recurrenceEditorYearlyOf": "vom",
    "recurrenceEditorYearlyRepeatEvery": "Wiederholung jedes",
    "recurrenceEditorYearlyRepeatOn": "Wiederholung am",
    "recurrenceEditorYearlyInterval": "Jahr(e)",
    "recurrenceEditorFrequenciesDaily": "Täglich",
    "recurrenceEditorFrequenciesMonthly": "Monatlich",
    "recurrenceEditorFrequenciesNever": "Nie",
    "recurrenceEditorFrequenciesWeekly": "Wöchentlich",
    "recurrenceEditorFrequenciesYearly": "Jährlich",
    "recurrenceEditorOffsetPositionsFirst": "Erster",
    "recurrenceEditorOffsetPositionsSecond": "Zweiter",
    "recurrenceEditorOffsetPositionsThird": "Dritter",
    "recurrenceEditorOffsetPositionsFourth": "Vierter",
    "recurrenceEditorOffsetPositionsLast": "Letzter",
    "recurrenceEditorWeekdaysDay": "Tag",
    "recurrenceEditorWeekdaysWeekday": "Wochentag",
    "recurrenceEditorWeekdaysWeekendday": "Wochenendtag",
    "recurrenceEditorEndAfter": "Nach",
    "recurrenceEditorEndOccurrence": "Vorkommnis(se)",
    "recurrenceEditorEndLabel": "Ende",
    "recurrenceEditorEndNever": "Nie",
    "recurrenceEditorEndOn": "Am",
    "deleteConfirmation": "Sind Sie sicher, dass Sie dieses Ereignis löschen möchten?",
    "deleteRecurringConfirmation": "Möchten Sie nur dieses Ereignis oder die gesamte Serie löschen?",
    "deleteOccurrence": "Aktuelles Vorkommen löschen",
    "deleteSeries": "Die Serie löschen",
    "deleteDialogTitle": "Ereignis löschen",
    "deleteRecurringDialogTitle": "Wiederkehrendes Element löschen",
    "dateTitle": "Datum",
    "timeTitle": "Zeit",
    "eventTitle": "Ereignis",
    "noEvents": "keine Ereignisse"
  },
  "sortable": {
    "noData": "Keine Daten"
  },
  "pager": {
    "itemsPerPage": "Einträge pro Seite",
    "info": "{0} - {1} von {2} Einträgen",
    "firstPage": "Zur ersten Seite",
    "previousPage": "Zur vorherigen Seite",
    "nextPage": "Zur nächsten Seite",
    "lastPage": "Zur letzten Seite",
    "page": "Seite",
    "of": "von"
  },
  "treelist": {
    "filterClearButton": "Zurücksetzen",
    "filterEqOperator": "Ist gleich zu",
    "filterNotEqOperator": "Ist ungleich zu",
    "filterIsNullOperator": "Ist null",
    "filterIsNotNullOperator": "Ist nicht null",
    "filterIsEmptyOperator": "Ist leer",
    "filterIsNotEmptyOperator": "Ist nicht leer",
    "filterStartsWithOperator": "Beginnt mit",
    "filterContainsOperator": "Enthält",
    "filterNotContainsOperator": "Enthält nicht",
    "filterEndsWithOperator": "Endet mit",
    "filterGteOperator": "Ist gleich oder größer wie",
    "filterGtOperator": "Ist größer wie",
    "filterLteOperator": "Ist kleiner oder gleich wie",
    "filterLtOperator": "Ist kleiner wie",
    "filterIsTrue": "Ist wahr",
    "filterIsFalse": "Ist falsch",
    "filterBooleanAll": "(Alle)",
    "filterAfterOrEqualOperator": "Ist gleich zu oder nach",
    "filterAfterOperator": "Ist nach",
    "filterBeforeOperator": "Ist vor",
    "filterBeforeOrEqualOperator": "Ist gleich zu oder vor",
    "noRecords": "Keine Einträge vorhanden"
  }
}
